export default __webpack_public_path__ + "static/media/PWDRegistrationSteps.88aaef04.png";